<div class="layout-container">
	<app-side-nav class="side-nav" 
	[identity]="activeIdentity$ | async" 
	[isAdministrator]="isAdministrator$ | async" 
	[teams]="teams$ | async" 
	[teamSelected]="teamSelected$ | async" 
	[planType]="planType$ | async"
	></app-side-nav>
	<div class="premium-container">
		<app-top-nav class="account-top-nav" [identity]="activeIdentity$ | async"></app-top-nav>
		<div class="premium-router-container">
			<div class="premium-router-inner-container">
				<router-outlet class="premium-router"></router-outlet>
			</div>
		</div>
	</div>
</div>